import InternalDocsList from "@/components/InternalDocsList";
import { PageHeader } from "@/components/common";

export default function InternalDocs() {
  return (
    <div data-testid="internal-docs-page">
      <PageHeader title="Interné doklady" subtitle="Doklady k zákazkám bez faktúry · nie sú daňové doklady" />
      <InternalDocsList />
    </div>
  );
}
